// @ts-ignore
import Card from "@pathwright/ui/src/components/card/Card"

import { Box } from "@chakra-ui/react"
import { InvitationContext } from "@pathwright/web/src/modules/api/generated"
import { default as WebInvitations } from "@pathwright/web/src/modules/invitation/Invitations"
import InvitationHeader from "./InvitationHeader"

const Invitations = ({
  card,
  context
}: {
  card: Card
  context: InvitationContext | null
}) => {
  return (
    <Card card={{ ...card }} navless>
      <InvitationHeader card={card} context={context} />
      <Box p={4}>
        <WebInvitations context={context} />
      </Box>
    </Card>
  )
}

Invitations.displayName = "Invitations"

export default Invitations
